import * as Yup from 'yup'

const StudentDetailFormValidations = () => {
    return Yup.object().shape({
        edupoint: Yup.number(),
        examFinisher: Yup.number()
    })
}

export { StudentDetailFormValidations }